import React from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import Mappings from '../../../Modules/Mappings/Mappings'
import PageLoader from '../../../SharedComponents/PageState/PageLoader'
import { describeConnection, useConnection } from '../../../../features/connections/connectionsApi'
import { PATH, paths } from '../../../../app/routes'
import Style from './ProductMappings.module.css'

/**
 * Full-page mapping workspace for one connector: entities in the left sidebar,
 * the Field Mapper canvas on the right. Opened from the connector's Mappings tab.
 */
const ProductMappings = ({ mode = 'entities', title = 'Mappings' }) => {
    const { connectorId } = useParams()
    const history = useHistory()
    const location = useLocation()
    const { connection, connectionCount, isLoading } = useConnection(connectorId)

    // Go back to the page that opened the mappings (My Products or Dashboard), else the connector page.
    const backTo = (location.state && location.state.from) || paths.productDetail(connectorId)
    const goBack = () => history.push(backTo)

    const renderContent = () => {
        if (!connection) {
            if (isLoading) {
                return <PageLoader message="Loading connector..." />
            }
            return (
                <div className="mp-empty-state">
                    {connectionCount > 0 ? 'Connector not found.' : 'No connectors found.'}{' '}
                    <Link to={PATH.MY_PRODUCTS}>Back to My Products</Link>
                </div>
            )
        }
        const connector = describeConnection(connection)
        return (
            <>
                <div className={Style.topBar}>
                    <button type="button" className={Style.backButton} onClick={goBack}>
                        <i className="uil-arrow-left" aria-hidden="true" />
                        Back
                    </button>
                    <div className={Style.titleBlock}>
                        <h4 className={Style.title}>{connector.displayName}</h4>
                        <span className={Style.subtitle}>{title}</span>
                    </div>
                </div>
                <div className={Style.workspace}>
                    <Mappings connector={connector} mode={mode} title={title} />
                </div>
            </>
        )
    }

    // No .main-content wrapper: it reserves 250px for the app sidebar, which this page hides.
    return (
        <div className={`myProducts newMyProducts ${Style.page}`}>{renderContent()}</div>
    )
}

export default ProductMappings
